import React from 'react'
import BillPay from 'src/app/BillPay/BillPay'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import BillPayAllAppRoute from 'src/navigation/appRoutes/billPayAll.appRoute'
import BillPayNeedsApprovalAppRoute from 'src/navigation/appRoutes/billPayNeedsApproval.appRoute'
import { billPayRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const BillPayAppRoute: AppRoute = {
  id: AppLocation.BillPay,
  routeProps: billPayRouteProps,
  component: <BillPay />,
  subRoutes: [BillPayAllAppRoute, BillPayNeedsApprovalAppRoute],
  meta: { contentType: SidenavContentType.Main },
}

export default BillPayAppRoute
